function removeUnderline() {
  const spans = document.querySelectorAll('.star-rating-design-one > span');

  spans.forEach((span) => {
    span.style.textDecoration = 'none';
  });
}

document.addEventListener('DOMContentLoaded', removeUnderline);
window.addEventListener('load', removeUnderline);

function setupReviewLinkHover() {
  const link = document.querySelector('a[href="#quoli-pdp"]');

  if (!link) return;

  // base state
  link.style.textDecoration = 'none';
  link.style.textTransform = 'none';

  // hover in
  link.addEventListener('mouseenter', () => {
    link.style.textDecoration = 'underline';
  });

  // hover out
  link.addEventListener('mouseleave', () => {
    link.style.textDecoration = 'none';
  });
}

document.addEventListener('DOMContentLoaded', setupReviewLinkHover);
window.addEventListener('load', setupReviewLinkHover);